import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Flame, Home, ClipboardList, Key } from "lucide-react";

function TabLink({ to, label, icon: Icon, isActive }) {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2 px-1 py-3 text-[14px] font-medium border-b-2 transition-colors ${
        isActive
          ? "border-slate-900 text-slate-900"
          : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </Link>
  );
}

export default function PropertiesLayout() {
  const location = useLocation();

  return (
    <>
      <div className="flex flex-col h-full bg-slate-50">
        {/* Header Area */}
        <div className="bg-white px-8 pt-8">
          <h1 className="text-[28px] font-bold text-slate-900 tracking-tight mb-6">
            Properties
          </h1>

          {/* Tabs */}
          <nav className="flex items-center gap-6 border-b border-slate-200">
            <TabLink
              to="/properties/seller"
              label="Seller"
              icon={Home}
              isActive={location.pathname === "/properties/seller" || location.pathname === "/properties"}
            />
            <TabLink
              to="/properties/buyer"
              label="Buyer"
              icon={ClipboardList}
              isActive={location.pathname === "/properties/buyer"}
            />
            <TabLink
              to="/properties/rental"
              label="Rental"
              icon={Key}
              isActive={location.pathname === "/properties/rental"}
            />
          </nav>
        </div>

        {/* Page Content */}
        <main className="flex-1 p-8 overflow-auto">
          <div className="max-w-[1400px] mx-auto space-y-6">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
}
